module.exports = __webpack_public_path__ + "img/LNB_qna.0355213c.svg";